import * as effects from 'redux-saga/effects';
import { wsActions } from '../../actions';
import { handleError } from '../../../handleError';

export function* handleMessageError({ error }) {
  try {
    yield effects.put(wsActions.setSocketsStatus('ERROR'));
    yield effects.put(wsActions.setSocketError(error)); // Записуємо помилку в Redux
  } catch (e) {
    yield handleError(e);
  }
}
